import { styled } from '@mui/material/styles';
import { AppBar, SvgIcon, SwipeableDrawer } from '@mui/material';
import { maxWidth } from '../../../sharedStyles/layoutStyles';
import {
  HEADER_HEIGHT_LG,
  HEADER_HEIGHT_SM,
  HEADER_LOGO_MOBILE_WIDTH,
  HEADER_LOGO_DESKTOP_WIDTH,
} from './constants/headerConstants';

export const StyledHeader = styled('header')(
  ({ theme, mobileOpen }) => `
  top: 0;
  left: 0;
  z-index: ${mobileOpen ? 2000 : 1000};
  position: sticky;
  background-color: ${theme.DS_palette.primary.white};

  `,
);

export const StyledAppBar = styled(AppBar)(
  ({ theme, $isDRSmileInactive }) => `
  position:relative;
   box-shadow: none;
   background-color: ${theme.DS_palette.primary.white};
   padding-top: 0;
    > .MuiToolbar-root {
      min-height: ${HEADER_HEIGHT_SM};
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-content: space-between;
      grid-template-rows: auto;
      padding-right: 2px;
      padding-left: ${theme.DS_spacing(['md'])};
      > svg:first-of-type {
        margin-left: -2px;
      }
      > button  {
         justify-self: end;
         margin-right: ${theme.DS_spacing(['xs'])};
       }
      > svg:first-of-type, > a:first-of-type {
       margin-top: 0 ;
   
     }
      > svg:first-of-type, > a:first-of-type > svg {
          width:  ${HEADER_LOGO_MOBILE_WIDTH} ;
     }
    }

   ${theme.breakpoints.up('md')} {
  
       > .MuiToolbar-root {
       grid-template-columns: auto 1fr auto;
       gap: 26px;
       padding-right: ${theme.DS_spacing(['sm'])};
      
       > svg:first-of-type {
       margin-left: 2px;
       }
       > a:first-of-type {
       margin-left: ${theme.DS_spacing(['xxs'])};
       }
        > button  {
         justify-self: end;
         margin-right: -1px;
       }
       
     }
   }
   
  ${theme.breakpoints.up('lg')} {

    > .MuiToolbar-root {
        ${maxWidth};
        min-height: ${HEADER_HEIGHT_LG};
       > *{
         align-self: start;
         padding-top: 18px;
         justify-content: space-evenly;
       }

       padding-right: ${theme.DS_spacing(['xxs'])};
       > svg:first-of-type {
       margin-left: 35px;
       }
       > a:first-of-type {
       margin-left: 33px;
       }
       > svg:first-of-type, > a:first-of-type { 
    
       margin-top:  ${$isDRSmileInactive ? `${theme.DS_spacing(['md'])}` : `-${theme.DS_spacing(['xxxs'])}`};

     }
 
     > svg:first-of-type, > a:first-of-type > svg {
        width: ${HEADER_LOGO_DESKTOP_WIDTH};
     }
     > svg:first-of-type, > a:first-of-type {
        z-index: 10;
     }
     
    @media (min-width: 1280px) and (max-width: 1400px) {
       padding-right: 0;
       > svg:first-of-type {
       margin-left: 0;
       }
       > a:first-of-type {
       margin-left: 0;
       }
    }
     
   }

  `,
);

export const StyledSvgLogo = styled(SvgIcon)(
  ({ theme }) => `
    width: 5.625rem;
    height: auto;
    fill: black;
    
    ${theme.breakpoints.up('md')} {
         width: 6.25rem;
    }
    
    ${theme.breakpoints.up('lg')} {
         width: 8.75rem;
    }
   
  `,
);

export const StyledSwipeableDrawer = styled(SwipeableDrawer)(
  ({ theme }) => `
     
  &.MuiDrawer-root .MuiDrawer-paper {
      top: unset;
      border-radius: 0;
      box-sizing: border-box;
      min-width: 100vw;
      padding:  ${HEADER_HEIGHT_SM} ${theme.DS_spacing(['md'])} ${theme.DS_spacing(['xxl'])};
        
   },
  `,
);

export const StyledIconsWrapper = styled('div')(
  () => `
     display: flex;
  `,
);

export const StyledWrapperProgressBar = styled('div')(
  () => `
    position: relative;
    z-index: 20000;
    width: 100%;
 
  `,
);

export const StyledWrapperTabletVisibleOnly = styled('div')(
  ({ theme }) => `
     display: none;
     ${theme.breakpoints.up('md')} {
      display: block;
      justify-self: end;
       
     }
     ${theme.breakpoints.up('lg')} {
      display: none;
     }
     
  `,
);

export const StyledWrapperDesktopVisibleOnly = styled('div')(
  ({ theme }) => `
     display: none;

     ${theme.breakpoints.up('lg')} {
      display: flex;
      
     }
  `,
);
